export default {
  name: 'marking--returnH',
  apiService: 'shoes',
  apiPath: '/admin/return_h',
};